var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { C as CustomEvents } from "./events-DeC3n8dp.js";
class ProductPrice extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "handleVariantPickerUpdate", (event) => {
      if (event.detail.data.productId !== this.dataset.productId) return;
      const newPrice = event.detail.data.html.querySelector(`product-price[data-product-id="${this.dataset.productId}"]`);
      this.updatePrice(newPrice);
    });
  }
  connectedCallback() {
    const section = this.closest(".shopify-section");
    if (!section) return;
    section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
  }
  updatePrice(newPrice) {
    if (this.innerHTML !== newPrice.innerHTML) {
      this.innerHTML = newPrice.innerHTML;
    }
  }
}
if (!customElements.get("product-price")) {
  customElements.define("product-price", ProductPrice);
}
